import React from 'react'
import { Helmet as ReactHelmet } from 'react-helmet-async'

import FaqJsonLd from 'lib/json-ld/faq'
import VideoJsonLd from 'lib/json-ld/video'

export default function withJsonLd (
  Component,
  { jsonLdSchemaName, getCreateArgs }
) {
  return function JsonLdComponent (props) {
    const JsonLd = getJsonLdSchema(jsonLdSchemaName)
    const jsonLd = JsonLd ? JsonLd.create(getCreateArgs(props)) : null

    return (
      <>
        {jsonLd && <ReactHelmet>{jsonLd.injectIntoDOM()}</ReactHelmet>}
        <Component {...props} />
      </>
    )
  }
}

// the cases to switch on should match the exact name of the schema,
// as it will be used to generate the schema class used. For example,
// use 'FAQPage' for FAQ schema, not 'faq' or 'FaqJsonLd'
function getJsonLdSchema (jsonLdSchemaName) {
  switch (jsonLdSchemaName) {
    case 'FAQPage':
      return FaqJsonLd
    case 'VideoObject':
      return VideoJsonLd
    default:
      return null
  }
}
